export enum UserRightRolesEnum {
    ShopAdmin="ShopAdmin",
    CountryManager="CountryManager",
    PatientManager="PatientManager",
    AdvancedMode="AdvancedMode",
}
